/**
 * Default State
 */
const defaultState = {
  publications: {
    obras: [],
    proyectos: [],
    desarrollos: [],
    banner: [],
    historia: [],
  },
};

/**
 * Types
 */
const types = {
  PUBLICATIONS_SET: 'PUBLICATIONS/SET',
};

/**
 * Reducer
 */
const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.PUBLICATIONS_SET:
      return {
        ...state,
        publications: action.publications
      };
    default:
      return state;
  }
};

export { types, reducer };
